import SvgIcon from '@mui/material/SvgIcon';

export default function OfficeDeleteIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg
                viewBox="0 0 24 24"
                version="1.1"
                id="svg1"
                width="576"
                height="576"
                xmlns="http://www.w3.org/2000/svg">
                <defs id="defs1" />
                <path
                    id="path1"
                    fill='currentColor'
                    d="m 9.5,3 -1,1 H 5 V 6 H 19 V 4 h -3.5 l -1,-1 z M 6,7 v 12 c 0,1.1 0.9,2 2,2 h 8 c 1.1,0 2,-0.9 2,-2 V 7 Z m 3.3320312,1.0742188 h 5.5058598 v 5.0917972 h 2.203125 V 19.53125 H 12.636719 V 16.986328 H 11.535156 V 19.53125 H 7.1308594 v -8.910156 h 2.2011718 z m 1.1015628,1.2734374 v 1.2734378 h 1.101562 V 9.3476562 Z m 2.203125,0 v 1.2734378 h 1.099609 V 9.3476562 Z M 8.2304688,11.892578 v 1.273438 h 1.1015624 v -1.273438 z m 2.2031252,0 v 1.273438 h 1.101562 v -1.273438 z m 2.203125,0 v 1.273438 h 1.099609 v -1.273438 z m -4.4062502,2.546875 v 1.273438 h 1.1015624 v -1.273438 z m 2.2031252,0 v 1.273438 h 1.101562 v -1.273438 z m 2.203125,0 v 1.273438 h 1.099609 v -1.273438 z m 2.201172,0 v 1.273438 h 1.101562 v -1.273438 z m -6.6074222,2.546875 v 1.271484 h 1.1015624 v -1.271484 z m 6.6074222,0 v 1.271484 h 1.101562 v -1.271484 z" />
            </svg>

        </SvgIcon>)
}